import { UserModel } from '@bp-core/src/lib/proto/common-message.pb';
import { ListUserCodeResponse } from '@bp-core/src/lib/proto/user.pb';

/** Destino de la entrada BetterplanUS, el mismo de siempre. */
export const BETTERPLAN_US_LINK = '/ibkr/activate';

/**
 * Si el menú ofrece BetterplanUS: Vector Capital activo y una invitación BP_US con estado. Es la
 * condición que tenía el menú lateral; desde 062-documentos la entrada vive en el menú de
 * usuario (FR-002, FR-003).
 */
export function showsBetterplanUs(
  user: UserModel | undefined,
  invitations: ListUserCodeResponse | undefined,
): boolean {
  const hasActiveVector = (user?.userFinancialEntities ?? []).some(
    entity => entity.financialEntity?.uuid === 'vector' && entity.status === 'active',
  );
  return (
    hasActiveVector && (invitations?.values ?? []).some(invitation => !!invitation.status?.length)
  );
}
